// extracted by mini-css-extract-plugin
export default {"img":"KeyHighlights_img__ZFN+Q","homeImg":"KeyHighlights_homeImg__oE5rU","parentContainer":"KeyHighlights_parentContainer__G+G9r","content":"KeyHighlights_content__LIvlB"};